import { GoogleCalendarForm } from '@/features/sources/components/GoogleCalendarForm';
import { Box, Button, Flex, Icon, Text } from '@/ui';

type Props = {
  onBack: () => void;
  onAdded: (feedId: string) => void;
};

export const GoogleCalendarSource = ({ onBack, onAdded }: Props) => (
  <Box maxW="540px">
    <Flex align="center" gap={3} mb={6}>
      <Button
        color="ink.soft"
        flexShrink={0}
        h="auto"
        minW={0}
        p={0}
        variant="link"
        onClick={onBack}
      >
        <Icon icon="ArrowLeft" size={4} />
      </Button>
      <Text
        color="ink.strong"
        fontSize="26px"
        fontWeight={700}
        letterSpacing="-0.02em"
      >
        Connect Google Calendar
      </Text>
    </Flex>

    <GoogleCalendarForm
      launchOnRedirect="source-google-connected"
      onAdded={onAdded}
    />
  </Box>
);
